export default __webpack_public_path__ + "static/media/14.83cfd8b6.png";